( function( $ ) {
  if ( $( '.__testimonials' ).length > 0  ) {
    $( '.__testimonial_slider' ).slick( {
      autoplay      : false,
      autoplaySpeed : 4000,
      lazyLoad      : "progressive",
      speed         : 600,
      dots          : true,
      cssEase       : "cubic-bezier(0.87, 0.03, 0.41, 0.9)",
      prevArrow     : '<button type="button" class="slick-prev"></button>',
      nextArrow     : '<button type="button" class="slick-next"></button>'
    } );
  }
} ) ( jQuery );